module.exports = __webpack_public_path__ + "img/England.8f238273.svg";